export default {
  translations: {
    'Bill to': {
      'hrk': 'Kupac'
    },
    'Delivery': {
      'hrk': 'Dostava'
    },
    'Discount': {
      'hrk': 'Rabat'
    },
    'Item': {
      'hrk': 'Artikl'
    },
    'Invoice': {
      'hrk': 'Racun'
    },
    'Invoice ID': {
      'hrk': 'Šifra Racun'
    },
    'Paid': {
      'hrk': 'Plaćeno'
    },
    'Quantity': {
      'hrk': 'Količina'
    },
    'Quote': {
      'hrk': 'Ponuda'
    },
    'same as billing address': {
      'hrk': 'jednaka kao adresa isporuke'
    },
    'Ship to': {
      'hrk': 'Mjesto isporuke'
    },
    'Subtotal': {
      'hrk': 'Ukupna vrijednost bez PDV -a'
    },
    'To Pay': {
      'hrk': 'Za platiti'
    },
    'Total': {
      'hrk': 'Ukupno'
    },
    'Total weight': {
      'hrk': 'Ukupna težina'
    },
    'Unit price': {
      'hrk': 'Cijena'
    },
    'Weight': {
      'hrk': 'Težina'
    }

  },
  get (str, lang) {
    if (this.translations.hasOwnProperty(str)) {
      if (this.translations[str].hasOwnProperty(lang)) {
        return this.translations[str][lang]
      }
    }
    return str
  },
}